import { styled } from '@mui/system';

export const Root = styled('section')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(),
  alignItems: 'center'
}));

export const Content = styled('section')(({ theme }) => ({
  backgroundColor: theme.palette.grey[300],
  padding: theme.spacing(0.75, 1)
}));

export const Triangle = styled('span')(({ theme }) => ({
  width: 0,
  height: 0,
  borderTop: '18px solid transparent',
  borderBottom: '18px solid transparent',
  borderLeft: `14px solid ${theme.palette.grey[300]}`
}));
